import React, { useEffect, Fragment } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { PageTitle, PageContent, PageLead, EmptyOrdersLead } from 'components/Pages';
import { Order, LoadingOrder } from 'components/Order';
import Pagination from 'components/Pagination';
import { getData } from 'redux/actions';
import { useQuery, useScrollToTop } from 'hooks';

const renderLeadValue = (totalItems) => {
    if (Number(totalItems) === 1) {
        return `1 zamówienie`;
    } else if (Number(totalItems) > 4) {
        return `${totalItems} zamówień`;
    } else {
        return `${totalItems} zamówienia`;
    }
};

const OrdersPage = () => {
    const titleProps = {
        title: !isMobile && 'Moje Zamówienia',
        url: isMobile && '#',
    };
    const dispatch = useDispatch();
    const page = useQuery({ param: 'page' });
    const { orders: ordersData, loading, totalItems, currentPage, nextPage, previousPage, totalPages } = useSelector(
        (state) => state.orders,
    );
    const paginationProps = {
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        path: '/orders',
    };

    useScrollToTop();

    useEffect(() => {
        dispatch(getData(page || 1));
    }, [page, dispatch]);

    return (
        <section className="page">
            <PageTitle {...titleProps}>{isMobile && 'Moje Zamówienia'}</PageTitle>
            <PageLead size={!ordersData && 'big'} loading={loading}>
                {ordersData ? <p>Złożyłeś już {renderLeadValue(totalItems)}</p> : <EmptyOrdersLead />}
            </PageLead>
            <PageContent>
                {loading ? (
                    <LoadingOrder />
                ) : (
                        <Fragment>
                            {ordersData && ordersData.map((order, index) => <Order key={`order-${index}`} {...order} />)}
                            {totalPages > 1 && <Pagination {...paginationProps} />}
                        </Fragment>
                    )}
            </PageContent>
        </section>
    );
};

export default OrdersPage;
